import { Selector } from "../common/Selector";
import { RecentAnswer } from "winslow-core";

type NameSelectorProps = {
  responses: RecentAnswer[];
  onChange: (value: string) => void;
};

export const NameSelector = ({ responses, onChange }: NameSelectorProps) => {
  // Map to store unique names and associated avatar URLs
  const nameMap: Map<string, string | undefined> = new Map();

  responses.forEach((response: RecentAnswer) => {
    if (response.name) {
      nameMap.set(response.name, response.avatarURL);
    }
  });

  // Convert the map to an array of Option objects
  const options = Array.from(nameMap.entries()).map(([name, avatarUrl]) => ({
    value: name,
    label: name,
    imageUrl: avatarUrl,
  }));

  // Add the "(no filter)" option at the beginning
  options.unshift({
    value: "",
    label: "(no filter)",
    imageUrl: undefined,
  });

  return <Selector options={options} onChange={onChange} roundIcons={true} />;
};
